export default {
  common: {
    account: 'アカウント',
    signOut: 'サインアウト'
  },
  views: {
    dashboard: {
      title: 'ダッシュボード'
    },
    login: {
      username: 'ユーザー名',
      password: 'パスワード',
      signIn: 'ログイン',
      invalidLogin: '{{email}}はログインできません。'
    },
    reports: {
      title: 'レポート',
      id: '番号',
      reportGroupName: '期間選択'
    },
    details: {
      title: '詳細',
      rawData: 'RAW DATA',
      excel: 'Excel',
      pdf: 'PDF'
    }
  },
  validation: {
    required: '{{name}}を入力してください',
    requiredSelect: '選択してください',
    invalid: '有効な{{name}}を入力してください',
    password: '大文字、小文字、記号、数字を組み合わせた8文字以上で作成ください',
    number: '半角数字を入力してください'
  }
};
